module.exports = __webpack_public_path__ + "img/YoushouldBeDancing.42908b1d.jpg";